import { tracking } from '@navio/observability';

import { resetBookingFunnel } from './bookingFunnel';
import { commonTrackingEvents } from './events';
import { pickDefined } from './pickDefined';

type MoneyLike = {
  amount: number;
  currency?: string;
};

export type BookingOrderMoney = {
  amountGross?: MoneyLike | null;
  amountPaid?: MoneyLike | null;
};

export type BookingCreatedAllowProps = {
  bookingId?: number;
  isProposal?: boolean;
  brand?: string;
  paymentOption?: string;
  executingServiceDepartmentId?: number;
  executingServiceDepartmentName?: string;
  locationType?: 'mobile' | 'stationary';
  order?: BookingOrderMoney | null;
};

// Confirmed paid total is recorded by the backend on capture (`mark_captured`
// → OpenPanel `__revenue` in major units). Create only reports booked GMV
// (`amountGross`) as event props — never `__revenue`.
export function toBookingCreatedMoneyProps(order?: BookingOrderMoney | null) {
  const amountGross = order?.amountGross?.amount;
  const amountPaid = order?.amountPaid?.amount;
  const currency = order?.amountPaid?.currency ?? order?.amountGross?.currency;
  return pickDefined({ amountGross, amountPaid, currency });
}

// Allow-list only. Callers often have a fat tracking bag (plates, address,
// mutation variables) — those must never reach Faro / OpenPanel / Mixpanel.
export function toBookingCreatedEventProps({
  order,
  bookingId,
  isProposal,
  brand,
  paymentOption,
  executingServiceDepartmentId,
  executingServiceDepartmentName,
  locationType
}: BookingCreatedAllowProps) {
  return {
    ...pickDefined({
      bookingId,
      isProposal,
      brand,
      paymentOption,
      executingServiceDepartmentId,
      executingServiceDepartmentName,
      locationType
    }),
    ...toBookingCreatedMoneyProps(order)
  };
}

export function trackBookingCreated(props: BookingCreatedAllowProps) {
  resetBookingFunnel();
  tracking.track(commonTrackingEvents.bookingCreated, toBookingCreatedEventProps(props));
}
